import React from "react";
import PropTypes from "prop-types";
import { remove } from "lodash"

import {
  SummaryText,
  TakeawayMessages,
  SkipSection,
  ReagentDragDrop,
  GelDragDropQuestion,
  //GelResults,
  MaterialsList,
  //FullWidthCard,
  SubHeading,
  Heading,
  QuestionCSCQ,
  QuestionColor,
  FullWidthImage,
  FullWidthAnimation,
  ProtocolTableActual,
  ProtocolTableIdeal,
  ResultsComparisonGel,
  ResultsComparisonPhotosynthesis,
  QuestionTable,
  ProtocolTableIdealGel,
  ColorPrediction
} from "@learningblocks/protocol-components";
import {
  //PlainText,
  FullWidthCard,
  HighlightHTML,
  GlossaryProvider,
  SingleSelectRedux,
  NoteBanner,
  //GelDragDropQuestion,
  SliderWidget,
} from "@learningblocks/storybook-components";
import {Log} from "@learningblocks/shared-components";

import { COMPONENT_TYPE } from "@learningblocks/protocol-constants/lib/Utilities";
import { getIndividialDataFromAirtable,  getIndividualGlossaryItem } from '@learningblocks/exp-constants/lib/Utilities';
import { API_DETAILS } from "../../../Constants";

function SliderImage(props){
  const [value, onChange] = React.useState(0);
  return (
    <SliderWidget
      {...props}
      key={props.id}
      className={'className'}
      value={value}
      onChange={onChange}
      animeAriaLabel={props.sliderAnimationAltText}
      sliderAriaLabel={getSliderAltText(props.sliderAriaLabel, value)}
    />
  );
};

function getSliderAltText(animation, value){
  switch (animation) {
    case 'CARBON_DIOXIDE_SLIDER':
      return `At ${value} seconds, the pH value of the solution is ${getCarbonSliderAltTextPh(value)}, and the color of the solution is ${getCarbonSliderAltTextColour(value)}.`;
    
    case 'LIGHT_DURATION_SLIDER':
      return ` At ${(value >= 12) ? 660 : value * 60} minutes, the pH value is ${getLightSliderAltTextPh(value)}, the solution is ${getLightSliderAltTextColour(value)}, and there is ${getLightSliderAltTextDescription(value)}.`;

    case 'ABSORBANCE_SLIDER':
      return `Drag the slider between absorbance values 0.11 to 1 to see the change in pH value. \nAt absorbance ${value}, the solution is ${getAbsorbanceliderAltTextColour(value)}, and the pH value is ${getAbsorbanceliderAltTextPh(value)}.`;
    
    case 'PH_SLIDER':
      return `At pH ${value/12.5}, the solution is ${getPhSliderAltColourDescription(value)}, and the absorbance is ${getPhSliderAltAbsorbanceDescription(value)}.`
  
    default:
      return animation;
  }
}

function getPhSliderAltAbsorbanceDescription(value){
  switch (value) {
    case 0:
      return '0.14';
      
    case 87.5:
      return '0.57';
  
    case 175:
      return '0.85';

    default:
      break;
  }
}

function getPhSliderAltColourDescription(value){
  switch (value) {
    case 0:
      return 'yellow';
      
    case 87.5:
      return 'green';
  
    case 175:
      return 'blue';

    default:
      break;
  }
}

function getLightSliderAltTextDescription(time){
  let value = time * 60;
  value = (value > 660) ? 660 : value
  console.log(value);
  
  if (value <= 0)
    return 'Far less oxygen than there is carbon dioxide';

  if (value <= 60)
    return 'Three times less oxygen than there is carbon dioxide';

  if (value <= 120)
    return 'Nearly as much oxygen as there is carbon dioxide';

  if (value <= 180)
    return 'Slightly more oxygen than there is carbon dioxide';

  if (value <= 240)
    return 'Three times more oxygen than there is carbon dioxide';

  if (value <= 300)
    return 'Five times more oxygen than there is carbon dioxide';

  if (value <= 660)
    return 'Much more oxygen than there is carbon dioxide';

}

function getLightSliderAltTextColour(time){
  let value = time * 60;
    if (value <= 0)
      return 'Greenish-yellow';

    if (value <= 60)
      return 'Muddy green';

    if (value <= 120)
      return 'Deep teal';

    if (value <= 180)
      return 'Deep, muddy blue';

    if (value <= 240)
      return 'Dark, muddy blue, bordering on navy';

    if (value <= 300)
      return 'Dark, muddy navy';

    if (value <= 660)
      return 'Dark navy';
}

function getLightSliderAltTextPh(time){
  let value = time * 60;
  if (value <= 0)
    return '6.7';

  if (value <= 60)
    return '7.1';

  if (value <= 120)
    return '7.4';

  if (value <= 180)
    return '7.7';

  if (value <= 240)
    return '7.9';

  if (value <= 660)
    return '8.0';

}

function getAbsorbanceliderAltTextColour(value){
  if(value < 30)
      return 'Yellow';

  if( value < 40)
    return 'Yellowish green';

  if (value < 60)
    return 'Green';  

  if (value < 70)
    return 'Bluish green';

  if (value < 80)
    return 'Greenish blue';

  if (value < 90)
    return 'Blue';

  if (value < 100)
    return 'Navy blue';
}

function getAbsorbanceliderAltTextPh(value){
  if (value < 0.11)
    return '6.0';

  if (value < 0.2)
    return '6.2';

  if (value < 0.3)
    return '6.4';

  if (value < 0.4)
    return '6.7';

  if (value < 0.5)
    return '6.9';

  if (value < 0.6)
    return '7.1';  

  if (value < 0.7)
    return '7.3';

  if( value < 0.8)
    return '7.5';

  if (value < 0.9)
    return '7.8';

  if (value < 1)
    return '8.0';
}

function getCarbonSliderAltTextColour(time){
  switch (time) {
    case 0:
    case 1:
    case 2:
    case 3: 
      return 'Deep blue';
    case 4:
      return 'Deep greenish-blue';

    case 5:
      return 'Dark green';  

    case 6:
      return 'Khaki green';

    case 7:
    case 8:
      return 'Medium green';

    case 9:
      return 'Green';

    case 10:
      return 'Greenish-yellow';
    default:
      break;
  }
}

function getCarbonSliderAltTextPh(time){
  switch (time) {
    case 0:
      return '8.0';

    case 1:
      return '7.9';

    case 2:
      return '7.7';

    case 3:
      return '7.5';

    case 4:
      return '7.4';

    case 5:
      return '7.3';  

    case 6:
      return '7.1';

    case 7:
      return '6.9';

    case 8:
      return '6.7';

    case 9:
      return '6.5';

    case 10:
      return '6.5';

    default:
      break;
  }
}

export function ContentItems(props) {

  const getGlossaryItem = () =>
    getIndividualGlossaryItem(
      getIndividialDataFromAirtable,
      API_DETAILS.URL,
      API_DETAILS.KEY
    );


  const { onOpenGlossary } = React.useContext(GlossaryProvider.Context);

  const renderByType = (component, key) => {
    switch (component.type) {
      case COMPONENT_TYPE.PLAIN_TEXT:
        return (
          <div style={{lineHeight: 1.5, color: "#333"}}>
            <HighlightHTML
              key={key}
              content={component.text}
              getContentData={getGlossaryItem()}
              openGlossary={onOpenGlossary}
            />
          </div>
        );
      case COMPONENT_TYPE.REAGENT_DRAG_DROP:
        return <ReagentDragDrop key={key} {...component} />;
      case COMPONENT_TYPE.BANNER:
        return (
          <div style={{marginTop: '24px'}}>
            <NoteBanner
              text={component.banner}
              openGlossary={onOpenGlossary}
              getContentData={getGlossaryItem()}
            />
          </div>
        );
      case COMPONENT_TYPE.RESULT_COMPARISON_GEL:
        return <ResultsComparisonGel key={key} {...component} />;
      case COMPONENT_TYPE.RESULT_COMPARISON_PHOTOSYNTHESIS:
        return <ResultsComparisonPhotosynthesis key={key} {...component} />;
      case COMPONENT_TYPE.GEL_DRAG_DROP_QUESTION:
        return <GelDragDropQuestion
                key={key}
                getContentData={getGlossaryItem()}
                openGlossary={onOpenGlossary}
                {...component}
              />;
      case COMPONENT_TYPE.QUESTION_TABLE:
        return <QuestionTable key={key} {...component} />;
      // case COMPONENT_TYPE.GEL_RESULTS:
      //   return <GelResults key={key} {...component} />;
      case COMPONENT_TYPE.MATERIALS_LIST:
        return <MaterialsList key={key} {...component} />;
      case COMPONENT_TYPE.SKIP_SECTION:
        return <SkipSection key={key} {...component} />;
      case COMPONENT_TYPE.SUMMARY_TEXT:
        return <SummaryText key={key} {...component} />;
      case COMPONENT_TYPE.PROTOCOL_TABLE_ACTUAL:
        return <ProtocolTableActual key={key} {...component} />;
      case COMPONENT_TYPE.PROTOCOL_TABLE_IDEAL:
        return <ProtocolTableIdeal key={key} {...component} />;
      case COMPONENT_TYPE.PROTOCOL_TABLE_IDEAL_GEL:
        return <ProtocolTableIdealGel key={key} {...component} />;
      case COMPONENT_TYPE.TAKEAWAY_MESSAGES:
        return <TakeawayMessages key={key} {...component} />;
      case COMPONENT_TYPE.FULL_WIDTH_IMAGE:
        return (
          <FullWidthImage
            key={key}
            className="fullWidthImage-item"
            getContentData={getGlossaryItem()}
            openGlossary={onOpenGlossary}
            {...component}
          />
        );
      case COMPONENT_TYPE.FULL_WIDTH_ANIMATION:
        return (
          <FullWidthAnimation
            key={key}
            className="fullWidthAnimation-item"
            getGlossaryItem={getGlossaryItem()}
            onOpenGlossary={onOpenGlossary}
            {...component}
          />
        );
      case COMPONENT_TYPE.SUB_HEADING:
        return <SubHeading key={key} {...component} />;
      case COMPONENT_TYPE.HEADING:
        return <Heading key={key} {...component} />;
      case COMPONENT_TYPE.FULL_WIDTH_CARD:
        return <FullWidthCard key={key} {...component} />;
      case COMPONENT_TYPE.SINGLE_SELECT_CSCQ:
        return <SingleSelectRedux key={key} {...component} />;
      case COMPONENT_TYPE.CSCQ:
      case COMPONENT_TYPE.DDQ:
      case COMPONENT_TYPE.MSCQ:
      case COMPONENT_TYPE.OEQ:
      case COMPONENT_TYPE.NEQ:
      case COMPONENT_TYPE.GROUPED_CSCQ:
        return <QuestionCSCQ
          key={key}
          openGlossary={onOpenGlossary}
          getContentData={getGlossaryItem()}
          {...component}
        />;
      case COMPONENT_TYPE.DNDQ_COLOR:
      case COMPONENT_TYPE.CSCQ_COLOR:
      case COMPONENT_TYPE.GROUPED_DNDQ:
        return <QuestionColor key={key} {...component} />;
      case COMPONENT_TYPE.SLIDER_IMAGE:
        return <SliderImage {...component} />;
      case COMPONENT_TYPE.COLOR_PREDICTION:
        return <ColorPrediction key={key} {...component} />;
      default:
        return null;
    }
  };
  const components = handleRandomizedcomponents(props.components)
  return components.map(item => (
    <Log
      key={item.id}
      logImpression
      event_type="sim_log_impression"
      component_type={item.type}
      component_id={item.id}
    >
      {renderByType(item)}
    </Log>
  ));
}

function handleRandomizedcomponents(contents){
  const groups = groupRandomComponents(contents);
  const cleanedContents = removeRestOfRandomComponents(groups, contents);
  return cleanedContents
}

function groupRandomComponents(contents) {
  const groups = {}
  for (let item of contents) {
    if (item.randomGroupId) {
      let id = item.randomGroupId + "";
      groups[id]
        ? groups[id].push(item)
        : groups[id] = [item];
    }
  }
  return groups
}

function removeRestOfRandomComponents(groups, contents) {
  for (let groupId in groups) {
    const randomGroup = groups[groupId];
    if (randomGroup.length > 1) {
      let chosenComponent = randomGroup[Math.floor(Math.random() * randomGroup.length)];
      remove(randomGroup, chosenComponent);

      for (let component of randomGroup) {
        remove(contents, component);
      }
    }
  }
  return contents
}

ContentItems.propTypes = {
  components: PropTypes.array.isRequired,
};
